module.exports = __webpack_public_path__ + "assets/ackwell.3f4c39b6.jpg";